// CoursesGroupTable.js
import React, { useMemo } from "react";
import { Badge } from "react-bootstrap";
import TanstackTable from "components/elements/advance-table/TanstackTable";

const CoursesGroupTable = ({ data }) => {
    const coursesColumns = useMemo(
        () => [
            {
                accessorKey: "id",
                header: () => (
                    <span style={{ fontWeight: "bold", color: "#224D99" }}>SN</span>
                ),
                size: 80,
            },
            {
                accessorKey: "courseTitle",
                header: () => (
                    <span style={{ fontWeight: "bold", color: "#224D99" }}>
                        Course Title
                    </span>
                ),
                cell: ({ getValue }) => (
                    <div>
                        <div style={{ fontWeight: 500, marginBottom: "4px" }}>
                            {getValue()}
                        </div>
                        {/* STATUS : COURSE WIP */}
                        {/* <Badge
                            bg="primary"
                            style={{
                                fontSize: "10px",
                                backgroundColor: "#224D99",
                                padding: "2px 8px"
                            }}
                        >
                            Active
                        </Badge> */}
                    </div>
                ),
            },
            {
                accessorKey: "courseDepartment",
                header: () => (
                    <span style={{ fontWeight: "bold", color: "#224D99" }}>
                        Department
                    </span>
                ),
                cell: ({ getValue }) => (
                    <span className="text-muted" style={{ fontSize: "13px" }}>
                        {getValue()}
                    </span>
                ),
            },
            {
                accessorKey: "courseDomain",
                header: () => (
                    <span style={{ fontWeight: "bold", color: "#224D99" }}>
                        Domain
                    </span>
                ),
                cell: ({ getValue }) => (
                    <span className="text-muted" style={{ fontSize: "13px" }}>
                        {getValue()}
                    </span>
                ),
            },
        ],
        []
    );

    return (
        <div style={{ minHeight: "400px" }}>
            {data && data.length > 0 ? (
                <TanstackTable
                    columns={coursesColumns}
                    data={data}
                    pagination={true}
                    pageSize={10}
                />
            ) : (
                <div
                    className="d-flex flex-column align-items-center justify-content-center"
                    style={{
                        minHeight: "300px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "2px dashed #dee2e6"
                    }}
                >
                    <div style={{ fontSize: "48px", marginBottom: "16px" }}>📚</div>
                    <h5 style={{ color: "#6c757d", marginBottom: "8px" }}>No Courses Found</h5>
                    <p style={{ color: "#adb5bd", textAlign: "center", margin: 0 }}>
                        No courses have been assigned to this training program yet.
                    </p>
                </div>
            )}
        </div>
    );
};

export default CoursesGroupTable;